module.exports = __webpack_public_path__ + "img/culture_bg.7dfa9b5f.png";